import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CustomCursor from './components/CustomCursor/CustomCursor';
import Nav from './components/Nav/Nav';
import ScrollToTop from './components/shared/ScrollToTop';
import Home from './pages/Home/Home';
import OurStory from './pages/OurStory/OurStory';
import ProjectGallery from './pages/ProjectGallery/ProjectGallery';
import FocusAreaPage from './pages/FocusAreaPage/FocusAreaPage';
import AboutUs from './pages/AboutUs/AboutUs';
import ContactUs from './pages/ContactUs/ContactUs';
import NotFound from './pages/NotFound/NotFound';

function App() {
  return (
    <BrowserRouter>
      <CustomCursor />
      <Nav />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/project-gallery" element={<ProjectGallery />} />
        <Route path="/focus-area" element={<FocusAreaPage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
